const uploadFileStatues = {
  sizeError: 'error_file_size',
  preparing: 'preparing',
  done: 'done',
};

export default uploadFileStatues;
